const slider = document.querySelector('.text-with-icons__list.mobile');
const slides = document.querySelectorAll('.text-with-icons__item.mobile');
let currentIndex = 0;

// Initiales Setup: Alle Slides außer dem ersten ausblenden
slides.forEach((slide, index) => {
    if (index !== 0) {
        slide.style.opacity = '0';
        slide.style.position = 'absolute';
        slide.style.top = '0';
        slide.style.left = '0';
        slide.style.width = '100%';
    }
});

function fadeNext() {
    // Aktuellen Slide ausblenden
    if (slides[currentIndex]) {
        slides[currentIndex].style.transition = 'opacity 0.4s ease-in-out';
        slides[currentIndex].style.opacity = '0';
    }
    
    // Zum nächsten Slide wechseln
    currentIndex = (currentIndex + 1) % slides.length;
    
    // Nächsten Slide einblenden
    if (slides[currentIndex]) {
        slides[currentIndex].style.transition = 'opacity 0.4s ease-in-out';
        slides[currentIndex].style.opacity = '1';
    }
}

setInterval(fadeNext, 2300);